<template>
    <input
        v-if="
            filter.current_shortcut_key != 'staff_identity' &&
            filter.current_shortcut_key != 'driver_commission_policy_identity' &&
            filter.current_shortcut_key != 'amount' &&
            filter.current_shortcut_key != 'polarity'
        "
        @keypress.enter="$parent.$parent.$parent.driver_commissions_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('models.attributes.driver_commissions.'+filter.current_shortcut_key)
        })"
        type="text"
    >

    <!--
    * ========================================================================
    * = 自行定義
    * ========================================================================
    -->
    <div
        v-else-if="filter.current_shortcut_key == 'staff_identity'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="staff in staffs"
            v-if="filter.columns.staff_identity == staff.identity">
            {{ staff.name }}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="staff in staffs"
                @click="filter.columns.staff_identity = staff.identity"
                class="item"
                :class="{
                    'selected active': filter.columns.staff_identity == staff.identity
                }">
                {{ staff.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DriverCcommissionsFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.driver_commissions_module
        },
        filter() {
            return this.current_store.filter
        },
        staffs() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.driver_commissions_module.staffs)
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>

<style scoped lang="scss">

</style>
